import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-expandAudioTrack",
  "use": "icon-expandAudioTrack-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-expandAudioTrack\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" /> \n\t<path d=\"M12.49,6.62l2.67,2.66H13.38v5.34h1.78l-2.67,2.66L9.83,14.62h1.78V9.28H9.83ZM6,4H19a1,1,0,0,1,1,1v8H16V11h2V6H7v5H9v2H7v5h8v2L6,20a1,1,0,0,1-1-1V5A1,1,0,0,1,6,4ZM18.66,16.94a2,2,0,0,0-2.27.72,2.2,2.2,0,0,0,0,2.49,2,2,0,0,0,2.25.79,2.11,2.11,0,0,0,1.4-2V15.42h2V14H18.66Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol